import { ArrowDown24Filled, Document24Filled } from '@fluentui/react-icons';

import { Typography } from '../../atoms/typography';
import { UnstyledButton } from '../../atoms/unstyled-button';

type TemplateDownloadProps = {
  title: string;
  description?: string;
  downloadPath: string;
  dataTestId?: string;
};
export const TemplateDownload = ({
  title,
  description,
  downloadPath,
  dataTestId,
}: TemplateDownloadProps) => {
  return (
    <div className="flex items-center justify-between rounded border p-4">
      <div className="flex gap-3">
        <Document24Filled className="text-primary-500" />
        <div className="flex flex-col gap-1">
          <Typography variant="h4">{title}</Typography>
          {description && (
            <Typography className="text-gray-500" variant="body4">
              {description}
            </Typography>
          )}
        </div>
      </div>
      <UnstyledButton
        className="bg-primary-50 rounded p-2 active:translate-y-0.5"
        data-testid={dataTestId}
      >
        <a href={downloadPath}>
          <ArrowDown24Filled className="text-primary-500" />
        </a>
      </UnstyledButton>
    </div>
  );
};
